import React, { useState, Fragment } from "react";
import { ReactSVG } from "react-svg";
import Collapse from "@mui/material/Collapse";
import styles from "./course_ranking_card.module.scss";

import { HiOutlineMinusSm } from "react-icons/hi";
import { AiOutlinePlus } from "react-icons/ai";
import { getAssets } from "@unisearch/helpers";

const CourseRankingCard = ({ rank, ...rest }) => {
  return (
    <div className={styles.course_ranking_card}>
      <div className={styles.ranking_heading}>
        <ReactSVG
          className={styles.trophy_icon}
          src={getAssets("assets/images/uni-profile/trophy-icon.svg")}
        />
        <div className={styles.rank_num}>
          {rank?.ranking[0]?.rankingVarying} {rank?.ranking[0]?.rankFrom}{" "}
          {rank?.ranking[0]?.rankTo && parseInt(rank?.ranking[0]?.rankTo) > 0
            ? `- ${rank?.ranking[0]?.rankTo}`
            : ""}
        </div>
        <div className={styles.rank_year}>
          in {rank?.ranking[0]?.rankingYear}
        </div>
      </div>

      <div className={styles.ranking_title}>
        {rank.rankingCompanyName}{" "}
        <span>( {rank?.ranking[0]?.type.rankingTypeName} )</span>
      </div>

      {rank.ranking &&
        rank.ranking.length > 0 &&
        rank.ranking.map((item, i) => {
          if (i > 0) {
            return (
              <Fragment key={i}>
                <div
                  className={`${styles.rank_list}`}
                  onClick={() => handleCollapse(item.id)}
                >
                  <span className={styles.num}>
                    {item?.rankingVarying}
                    {item?.rankFrom}{" "}
                    {item?.rankTo && parseInt(item?.rankTo) > 0
                      ? ` - ${item?.rankTo}`
                      : ""}
                    ,
                  </span>
                  <span className={styles.text}>
                    {item?.type.rankingTypeName}, {item?.rankingYear}
                  </span>
                </div>
              </Fragment>
            );
          }
        })}
    </div>
  );
};

export default CourseRankingCard;
